import { useEffect } from "react";
import styled from "styled-components";
import PageTemplate from "../component/PageTemplate.tsx";
import ImgBanner from "../assets/img/introduction/banner.png";

import { useContext } from "react";
import { WrapperContext } from "../component/WrapperContext.tsx";
import INFO from "../setting/INFO.jsx";

const Main = styled.div`
  width: 100%;
  height: 100%;
  text-align: left;
  padding: ${(props) => (!props.isMobile ? "25px 0 30px 10px" : "25px 0 30px 0")};
`;

const Title = styled.span`
  display: block;
  width: max-content;
  max-width: ${(props) => (!props.isMobile ? "100%" : "fit-content")};
  margin-left: 10px;
  font-family: SCDream5;
  font-size: 17px;
`;

const Map = styled.iframe`
  width: ${(props) => (!props.isMobile ? "700px" : "100%")};
  height: 400px;
  margin-top: 10px;
  margin-bottom: ${(props) => (!props.isMobile ? "50px" : "30px")};
`;

export default function Location() {
  const { isMobile } = useContext(WrapperContext);

  return (
    <PageTemplate bannerImage={ImgBanner}>
      <Main isMobile={isMobile}>
        <Title isMobile={isMobile}>{INFO.COMPANY_ADDRESS}</Title>
        <Map
          src={INFO.GOOGLE_LOCATION}
          width="600"
          height="450"
          className="google-map"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          isMobile={isMobile}
        ></Map>
      </Main>
    </PageTemplate>
  );
}
